import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { IMachineStatus } from 'src/app/modules/widget/interfaces/machine-status';

@Component({
  selector: 'app-team-feature',
  templateUrl: './team-feature.component.html',
  styleUrls: ['./team-feature.component.scss'],
})
export class TeamFeatureComponent implements OnInit, OnChanges {
  @Input() public feature: IMachineStatus;
  public machine: IMachineStatus;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  ngOnInit() {
    const customEvent = {
      modal_widget: 'asarco_state',
      tab_modal: 'asarco_state_team-feature',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.feature && changes.feature.currentValue) {
      const curr = changes.feature.currentValue;
      this.machine = {
        ...curr,
        machineModelName: curr.machineModelName ?? '-',
        machineName: curr.machineName ?? '-',
        hourStart: curr.hourStart ?? '-',
        fuelStart: curr.fuelStart !== null && curr.fuelStart !== undefined ? `${changes.feature.currentValue.fuelStart}%` : '-',
      };
    }
  }
}
